export default __webpack_public_path__ + "static/media/StaticPage1.20e64e2d.txt";